import React from 'react';

import RegisterModel from '../../models/Register';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { FormControl, FormControlLabel, TextField, Select, InputLabel, Button, OutlinedInput, Checkbox }from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';

import AccountCircle from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';

import menuIcon from '../../assets/FD_Logo.png';

import appStyles from '../../App/app.module.css';
import style from '../login/login.module.css';
import { Check, Clear } from '@material-ui/icons';
import {isPasswordSecure} from '../../utils/authentication';

const styles = (theme: any) =>

  createStyles({
    field: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      marginBottom: '10px',
    },
    button: {
      margin: theme.spacing.unit,
      marginTop: '20px'
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    loginInput: {
      backgroundColor: 'white',
      padding: '14px 12px',
      borderRadius: '10px',
      fontSize: '14px'
    },
    loginLabel: {
      color: '#FFF !important',
      fontSize: '16px',
      backgroundColor: 'var(--primaryblue)',
      borderRadius: '20px',
      padding: '5px 12px'
    },
    materialIcon: {
      fontSize: '30px'
    }
  });

interface RegisterProps  {
  fields: RegisterModel;
  errorFields: { email: string, passwordRepeat: string };
  companies: Array<{id: number, name: string, role: string}>;
  companyValue: string;
  submit: any;
  termsAndConditionsOnClick: () => void;
  change: (event: any) => void;
  selectCompany: (event: any) => void;
  classes: any;
};

const Register = (props: RegisterProps) => {

  const { classes } = props;

  const companyOptions: Array<JSX.Element> = props.companies.map((company: {id: number, name: string, role: string }, index: number) => (

    <option key={ index } value={ company.role + '_' + company.id } >{ company.name }</option>
    ));

  let {allTypesCharsPassword, valid, atLeast8CharPassword} = isPasswordSecure(props.fields.password);

  return (
    <div className={`${style.loginRow} ${style.loginContainer}`} >

      <div className={ style.loginRow }>
          <img alt="logo" src={ menuIcon } className={ style.logoImg} />
          <h1 className={ style.loginHeader }>TryPod Register</h1>
      </div>

      <div className={ style.loginRow }>

        <div className={ style.loginCol }>

          <form className={ appStyles.col } onSubmit={ props.submit }>
                  
            <FormControl>
            <TextField
                id="first_name"
                name='first_name'
                label=""
                className={ classes.field }
                value={ props.fields.firstName }
                onChange={ props.change }
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="First Name"
              />
              
              <TextField
                id="last_name"
                name='last_name'
                label=""
                className={ classes.field }
                value={ props.fields.lastName }
                onChange={ props.change }                                
                margin="normal"
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="Last Name"
              />

              <TextField
                id="tel"
                name='tel'
                label=""
                className={ classes.field }
                value={ props.fields.tel }
                onChange={ props.change }                                
                margin="normal"
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="Phone"
              />

              <TextField
                id="email"
                name='email'
                label=""
                className={ classes.field }
                value={ props.fields.email }
                onChange={ props.change }                                
                error={ props.errorFields.email !== '' }
                helperText={ props.errorFields.email !== '' ? props.errorFields.email : ' '}
                margin="normal"
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="Email"
              />

              <TextField
                id="password"
                name='password'
                label=""
                type="password"
                className={ classes.field }
                value={ props.fields.password }
                onChange={ props.change }                                
                margin="normal"
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="Password"
              />

              <TextField
                id="password_repeat"
                name='password_repeat'
                type="password"
                label=""
                className={ classes.field }
                value={ props.fields.passwordRepeat }
                onChange={ props.change }                                
                error={ props.errorFields.passwordRepeat !== '' }
                helperText={ props.errorFields.passwordRepeat !== '' ? props.errorFields.passwordRepeat : ' '}
                margin="normal"
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon color="primary" className={ classes.materialIcon }/>
                    </InputAdornment>
                  ),
                  classes: { input: classes.loginInput }
                }}
                placeholder="Repeat password"
              />
              <div className={style.passwordPolicyContainer}>
                <div className={style.passwordPolicyHeader}>
                    Password Policy:
                </div>
                <div className={style.passwordPolicyConditions}>
                  {atLeast8CharPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={style.greyText}>Must be at least 8 characters</span>
                </div>
                <div className={style.passwordPolicyConditions}>
                  {allTypesCharsPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={style.greyText}>Must contain one upper case letter, one number and a special character</span>
                </div>
              </div>
              <br/>
              <FormControl>

              <Select 
                native
                value={ props.companyValue }
                onChange={ props.selectCompany }
                className={ classes.field }
                inputProps={{
                  name: 'company',
                  id: 'company',
                  classes: {
                    icon: classes.blue
                  },
                }}
                placeholder=" Select Company"
                required
              >
                <option />
                { companyOptions }
              </Select> 
              </FormControl>

              <FormControlLabel
                control={
                  <Checkbox
                    id="terms"
                    name='terms'
                    className={ classes.field }
                    checked={props.fields.terms}
                    onChange={props.change}
                    value="primary"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                }
                label={<span>I agree with the <a href={'#'} onClick={props.termsAndConditionsOnClick}>Terms and Conditions</a></span>}
              />

              <Button type="submit" color="primary" variant="contained" className={ classes.button } >Register</Button>

            </FormControl>
          </form>

        </div>
      </div>
    </div>

  );
};

export default withStyles(styles)(Register);